import {useState} from 'react'
import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {toAbsoluteUrl} from '../../../_gori/helpers'
import {PublicWrapper} from '../../modules/common/components/PublicWrapper'
import {StartFreeToday} from '../landing/components/StartFreeToday'
import {ROUTES} from '../../../_gori/constants'

const integrations = [
  {
    key: 'shopify',
    logo: '/media/gori/integrations/shopify/shopify-logo.svg',
    path: ROUTES.INTEGRATIONS.SHOPIFY,
  },
  {
    key: 'walmart',
    logo: '/media/gori/integrations/walmart/walmart-logo.svg',
    path: ROUTES.INTEGRATIONS.WALMART,
  },
  {
    key: 'ebay',
    logo: '/media/gori/integrations/ebay/ebay-logo.svg',
    path: ROUTES.INTEGRATIONS.EBAY,
  },
  {
    key: 'tiktok',
    logo: '/media/gori/integrations/tiktok/tiktok-logo.svg',
    path: ROUTES.INTEGRATIONS.TIKTOK,
  },
  {
    key: 'temu',
    logo: '/media/gori/integrations/temu/temu-logo.webp',
    path: ROUTES.INTEGRATIONS.TEMU,
  },
  {
    key: 'shipstation',
    logo: '/media/gori/integrations/shipstation/shipstation-logo.svg',
    path: ROUTES.INTEGRATIONS.SHIPSTATION,
  },
  {
    key: 'woocommerce',
    logo: '/media/gori/integrations/woocommerce/woocommerce-logo.svg',
    path: ROUTES.INTEGRATIONS.WOOCOMMERCE,
  },
  {
    key: 'amazon',
    logo: '/media/gori/integrations/amazon/amazon-logo.svg',
    path: ROUTES.INTEGRATIONS.AMAZON,
    comingSoon: true,
  },
]

const carriers = [
  {key: 'usps', logo: '/media/gori/carrier-logos/Integration-page/usps.svg'},
  {key: 'ups', logo: '/media/gori/carrier-logos/ups.png'},
  {key: 'fedex', logo: '/media/gori/carrier-logos/Integration-page/fedex.svg'},
  {key: 'uniuni', logo: '/media/gori/carrier-logos/Integration-page/uniuni.webp'},
  {key: 'gofo', logo: '/media/gori/carrier-logos/Integration-page/gofo.svg'},
  {key: 'dhl', logo: '/media/gori/carrier-logos/Integration-page/dhl-express.webp'},
  {key: 'ontrac', logo: '/media/gori/carrier-logos/Integration-page/ontrac.svg'},
  {key: 'horizon', logo: '/media/gori/carrier-logos/Integration-page/horizon.webp'},
  {key: 'cainiao', logo: '/media/gori/carrier-logos/Integration-page/cainiao.webp'},
  {key: 'amazon', logo: '/media/gori/integrations/amazon/amazon-logo.svg'},
]

export function IntegrationsPage() {
  const intl = useIntl()
  const [activeTab, setActiveTab] = useState<'integrations' | 'carriers'>('integrations')

  return (
    <PublicWrapper>
      <section className='integrations-hero'>
        <div className='container'>
          <h1 className='integrations-hero-title'>
            {intl.formatMessage({id: 'INTEGRATIONS_TITLE'})}
          </h1>
          <p className='integrations-hero-subtitle'>
            {intl.formatMessage({id: 'INTEGRATIONS_SUBTITLE_1'})}
          </p>
          <p className='integrations-hero-subtitle'>
            {intl.formatMessage({id: 'INTEGRATIONS_SUBTITLE_2'})}
          </p>
          <Link
            to={ROUTES.AUTH.REGISTRATION}
            className='btn btn-outline btn-primary darker hover-orange fs-4 fw-boldest text-capitalize rounded-pill py-3 px-6 mx-auto mt-8 releases-hero-btn'
          >
            {intl.formatMessage({id: 'EXPLORE_SHIPBAE'})}
          </Link>
        </div>
      </section>

      <section className='integrations-partners'>
        <div className='container'>
          <div className='integrations-tabs'>
            <button
              className={clsx('integrations-tab', {active: activeTab === 'integrations'})}
              onClick={() => setActiveTab('integrations')}
            >
              {intl.formatMessage({id: 'INTEGRATIONS_TAG'})}
            </button>
            <button
              className={clsx('integrations-tab', {active: activeTab === 'carriers'})}
              onClick={() => setActiveTab('carriers')}
            >
              {intl.formatMessage({id: 'CARRIERS_TAG'})}
            </button>
          </div>

          <div className='integrations-partners-grid'>
            {activeTab === 'integrations'
              ? integrations.map((item) =>
                  item.comingSoon ? (
                    <Link
                      key={item.key}
                      to={item.path}
                      className='integrations-partners-card coming-soon'
                    >
                      <img src={toAbsoluteUrl(item.logo)} alt={item.key} />
                      <div className='coming-soon-overlay mb-8'>
                        <span className='fs-2'>{intl.formatMessage({id: 'COMING_SOON'})}</span>
                        <img
                          src={toAbsoluteUrl('/media/gori/integrations/lock.svg')}
                          alt='lock'
                          className='coming-soon-lock'
                        />
                      </div>
                    </Link>
                  ) : (
                    <Link key={item.key} to={item.path} className='integrations-partners-card'>
                      <img src={toAbsoluteUrl(item.logo)} alt={item.key} />
                    </Link>
                  )
                )
              : carriers.map((item) => (
                  <div key={item.key} className='integrations-partners-card carrier'>
                    <img src={toAbsoluteUrl(item.logo)} alt={item.key} />
                  </div>
                ))}
          </div>
        </div>
      </section>

      <StartFreeToday />
    </PublicWrapper>
  )
}
